/*
  fk-store-chips.js: the Google rating badge under each shop on the cards that
  are drawn in the browser (Zach, 2026-11-03):
    - the homepage and Visit Us cards, drawn by fk-store-ui.js;
    - the shop picker, also drawn by fk-store-ui.js;
    - the "choose a shop" cards on Ready Today (fk-ready-today).

  The badge markup comes from FKStores.stores[].chip, which fk-store-data
  renders with snippets/fk-loc-chip.liquid. It is the same badge as on the
  city pages, reading the same Google numbers.

  fk-store-ui.js redraws its cards whenever the shop changes and on every
  clock tick, which wipes anything added to them. So this watches each host
  and adds the badge back after every redraw.

  In the picker and on Ready Today, pressing a card chooses a shop. There the
  badge is a plain label rather than a link, so it can't take the shopper off
  the page by accident.
*/
(function () {
  function chipHTML(key) {
    var stores = (window.FKStores && window.FKStores.stores) || [];
    for (var i = 0; i < stores.length; i++) {
      if (stores[i].key === key) return stores[i].chip || '';
    }
    return '';
  }

  function makeChip(key, asLink) {
    var holder = document.createElement('div');
    holder.innerHTML = chipHTML(key);
    var link = holder.querySelector('.fk-loc-chip');
    if (!link || asLink) return link;
    var label = document.createElement('span');
    label.className = link.className;
    label.setAttribute('role', 'img');
    label.setAttribute('aria-label', link.getAttribute('aria-label') || '');
    label.innerHTML = link.innerHTML;
    return label;
  }

  /* Once per card: a card that already has a badge is left alone. */
  function addAfter(anchor, key, asLink) {
    if (!anchor || !key || !anchor.parentNode) return;
    if (anchor.parentNode.querySelector(':scope > .fk-loc-chip')) return;
    var chip = makeChip(key, asLink);
    if (chip) anchor.parentNode.insertBefore(chip, anchor.nextSibling);
  }

  function decorate() {
    document.querySelectorAll('.fk-store-card').forEach(function (card) {
      var shop = card.querySelector('[data-fk-store-confirm]');
      if (shop) addAfter(card.querySelector('.fk-store-card__row'), shop.getAttribute('data-fk-store-confirm'), true);
    });
    document.querySelectorAll('.fk-picker-card').forEach(function (card) {
      var pick = card.querySelector('[data-fk-pick]');
      if (pick) addAfter(card.querySelector('.fk-picker-card__addr'), pick.getAttribute('data-fk-pick'), false);
    });
    document.querySelectorAll('.fk-store-pick[data-fk-pick-card]').forEach(function (card) {
      addAfter(card.querySelector('.fk-store-pick__row'), card.getAttribute('data-fk-pick-card'), false);
    });
  }

  function watch() {
    decorate();
    document.querySelectorAll('[data-fk-store-cards], [data-fk-picker-stores], .fk-ready__stores').forEach(function (host) {
      if (host.hasAttribute('data-fk-chips-watched')) return;
      host.setAttribute('data-fk-chips-watched', '');
      new MutationObserver(decorate).observe(host, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);
})();